(function () {
    'use strict';

    a3_cabin_reports.directive('toolkit', toolkit);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name toolkit
    * @restrict E
    * @description
    *   Implementation of toolkit
    * @example
    *   Usage:
    *   <toolkit></toolkit>
    * @ngInject
    */
    function toolkit($timeout, ToolkitFactory, CustomerEventFactory) {  
        function link(scope) {
            scope.closeAlert = closeAlert;
            scope.goBack = goBack;
            
            scope.removeCustomerEvent = removeCustomerEvent;
            scope.addEditIncident = addEditIncident;
            scope.isRedeemed = false;
            scope.getIsRedeemed = getIsRedeemed;
            scope.submitCustomerEvent = submitCustomerEvent;
            scope.toggleDeleteAlert = toggleDeleteAlert;
            scope.validForm = validForm;
            scope.emailFormat = /^[a-zA-Z]+[a-zA-Z0-9._]+@[a-zA-Z]+\.[a-zA-Z.]{2,5}$/;
            scope.mobileFormat = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
            scope.FQTVNumber =  scope.passenger.Fqtv && scope.passenger.Fqtv.Carrier == "A3"? scope.passenger.Fqtv.Number : null;

            setupToolkit();
            function setupToolkit(){
                initializeToolkit(scope.passenger, function(toolKitItems){
                    scope.toolkit = toolKitItems;
                    scope.customerEvents = getCustomerEvents(toolKitItems, scope.flight.FlightId, scope.passenger.UCI);
                    if(scope.toolkit.some(x => x.Treatments.length)){
                        scope.treatmentAvailability({counter:scope.customerEvents.length});
                    }
    
                    if(scope.customerEvents.length>0){
                        scope.isListView = true;
                        scope.isEdit = false;
                    }
                    else{
                        addEditIncident();
                    }   
                });
            }


             /**
             * Save Customer Event in local storage
             */
            function submitCustomerEvent(){
                var customerEvent = {
                    ToolkitItemId : scope.newForm.selectedIncident.Id,
                    TreatmentId : scope.newForm.selectedTreatment,
                    PNR : scope.passenger.PNR,
                    UCI : scope.passenger.UCI,
                    FQTVNumber : scope.FQTVNumber,
                    FQTVTierLevel : scope.passenger.Fqtv && scope.passenger.Fqtv.Carrier == "A3" ? scope.passenger.Fqtv.TierLevel : null,
                    NPS : scope.newForm.NPS,
                    Comments : scope.newForm.CrewComments,
                    FlightId : scope.flight.FlightId,
                    FlightNo : scope.flight.FlightNo,
                    Departure : scope.flight.Departure,
                    Arrival : scope.flight.Arrival,
                    FlightDate : scope.flight.FlightDate,
                    Email : scope.newForm.passengerEmail,
                    TelephoneCode : scope.newForm.telephoneCode,
                    Mobile : scope.newForm.passengerMobile,
                    ContactLanguage : scope.newForm.contactLanguage,
                    GivenName : scope.passenger.GivenName,
                    Surname : scope.passenger.Surname,
                    SeatNo : scope.passenger.SeatNo,
                    ClassOfService: scope.passenger.Cabin,
                    LocalId: scope.newForm.LocalId ?  scope.newForm.LocalId : moment().valueOf() 
                };
                
                CustomerEventFactory.setCustomerEventToStorage(customerEvent);

                goBack();
                scope.isIncidentUpdated = true;
                $timeout(function () {
                    scope.isIncidentUpdated = false;
                }, 5000);
            }

            /**
             * Add or update a customer event
             * @param {object} customerEvent Selected customer event from list (edit mode)
             */
            function addEditIncident(customerEvent){
                scope.toolkitOptions = scope.toolkit.filter(x => !scope.customerEvents.some(y => y.Id == x.Id) && !x.Fallback).concat(scope.toolkit.filter(x => x.Fallback));
                scope.newForm={
                    selectedIncident : null,
                    selectedTreatment : null,
                    passengerEmail : null,
                    contactLanguage: "EN",
                    telephoneCode : "30", //Defaut value GR
                    passengerMobile: null,
                    NPS: null,
                    CrewComments: null
                };

                scope.isEdit = customerEvent == null || customerEvent == undefined;

                if(customerEvent){
                    scope.newForm={
                        selectedIncident : customerEvent,
                        selectedTreatment : customerEvent.CustomerEvent.TreatmentId,
                        passengerEmail : customerEvent.CustomerEvent.Email,
                        telephoneCode : customerEvent.CustomerEvent.TelephoneCode,
                        passengerMobile : customerEvent.CustomerEvent.Mobile,
                        contactLanguage : customerEvent.CustomerEvent.ContactLanguage,
                        NPS : customerEvent.CustomerEvent.NPS,
                        CrewComments : customerEvent.CustomerEvent.Comments,
                        LocalId : customerEvent.CustomerEvent.LocalId
                    };

                    if(!scope.toolkitOptions.some(x => x.Id == customerEvent.Id)){
                        scope.toolkitOptions.push(scope.toolkit.find(x => x.Id == customerEvent.Id));
                    }
                }
              
                scope.isListView = false;   //Change view
            }
            
            /**
             * Gets treatment redeem
             */
            function getIsRedeemed(item){
                scope.isRedeem = scope.toolkitOptions.flatMap(x => x.Treatments).filter(s => s.Id == item).map(f => f.IsRedeemed)[0];
            }

             /**
             * Go to Toolkit Items list view
             */
            function goBack(){
                scope.isIncidentUpdated = false;
                scope.deleteAlert = false;
                scope.isListView = true;
                scope.isEdit = false;
                scope.newForm = null;
                setupToolkit();
            }

            /**
             * Validate form before saving
             */
            function validForm(){
                // 1. Has a treatment selected
                // 2. Has NPS Score selected
                // 3. Has passenger email when nqtvNo is null or ( email or mobile is not null) 
                
                var validForm = false;
                var form = scope.newForm;
                
                if(form){
                    validForm = form.selectedIncident && form.selectedTreatment && form.NPS 
                        && (scope.FQTVNumber && (form.passengerEmail || form.passengerMobile) 
                            || (!scope.FQTVNumber && form.passengerEmail));
                }
                
                return validForm;
            }

             /**
             * Remove Customer Event from local storage
             */
            function removeCustomerEvent(){
                CustomerEventFactory.removeCustomerEvent(scope.newForm.LocalId);
                
                scope.treatmentAvailability({counter:scope.customerEvents.length});
                goBack();
            }

            /**
             * Close successful save alert
             */
            function closeAlert(){
                scope.isIncidentUpdated = false;
            }

            function toggleDeleteAlert(){
                scope.deleteAlert = !scope.deleteAlert;
            }
        }

        var passengerCategories = {
            none: 0,
            gold : 1,
            business : 2,
            silver : 3,
            blue : 4,
            economy: 5
        };

        /**
         * Gets all toolkit items and filter treatments depending on passenger's class
         * @param {object} passenger 
         * @param {function} callback 
         */
        function initializeToolkit(passenger, callback){
            ToolkitFactory.getToolkitItemsFromStorage(function(toolKitItems){
                var paxCategories = getPaxCategories(passenger);
                    toolKitItems.forEach(function(item){
                         var matchingCategories = paxCategories.some(function(category) {
                            return item.TouchpointCategories.includes(category);
                          });
                        var treatmentGroups = item.Treatments.groupByKey("PaxCategory");
    
                        if(matchingCategories && paxCategories.contains(passengerCategories.gold) && treatmentGroups[passengerCategories.gold]){
                            item.Treatments = treatmentGroups[passengerCategories.gold];
                        }
                        else if(matchingCategories && paxCategories.contains(passengerCategories.business) && treatmentGroups[passengerCategories.business]){
                            item.Treatments = treatmentGroups[passengerCategories.business];
                        }
                        else if(matchingCategories && paxCategories.contains(passengerCategories.silver) && treatmentGroups[passengerCategories.silver]){
                            item.Treatments = treatmentGroups[passengerCategories.silver];
                        }
                        else if(matchingCategories && paxCategories.contains(passengerCategories.blue) && treatmentGroups[passengerCategories.blue]){
                            item.Treatments = treatmentGroups[passengerCategories.blue];
                        }
                        else if(matchingCategories && paxCategories.contains(passengerCategories.economy) && treatmentGroups[passengerCategories.economy]){
                            item.Treatments = treatmentGroups[passengerCategories.economy];
                        }
                        else{
                            //No available treatments for this passenger
                            item.Treatments = [];
                        }
    
                        if(item.Treatments.length){
                            //Add 'No Treatment'
                            item.Treatments = item.Treatments.concat(treatmentGroups[passengerCategories.none])
                        }
                    });
              

                //Toolkit Items without treatments should not be visible
                toolKitItems = toolKitItems.filter(t => t.Treatments && t.Treatments.length);
                callback(toolKitItems);
            });
        }
       
        function getPaxCategories(passenger){
            var passengerClass = passenger.Cabin;
            var passengerFqtv = passenger.Fqtv && passenger.Fqtv.Carrier == "A3" ? passenger.Fqtv.TierDescription.toLowerCase() : null;

            var paxCategories = [];

            if(passengerClass == 'C'){
                paxCategories.push(passengerCategories.business);
            }
            if(passengerFqtv == 'gold'){
                paxCategories.push(passengerCategories.gold);
            }
            else if(passengerFqtv == 'silver'){
                paxCategories.push(passengerCategories.silver);
            }
            else if(passengerFqtv == 'blue'){
                paxCategories.push(passengerCategories.blue);
            }
            else if(passengerClass == 'Y'){
                paxCategories.push(passengerCategories.economy);
            }

            return paxCategories;
        }

      /**
       * Get customer events by flightId and UCI and attach them to their toolkitItem
       * @param {array} toolKitItems 
       * @param {number} flightId 
       * @param {number} UCI 
       */
        function getCustomerEvents(toolKitItems, flightId, UCI){
            var customerEvents=[];
            //All events created for this passenger & on this flight
            var storedCustomerEvents = CustomerEventFactory.getFlightCustomerEvents(flightId, UCI);
            
            storedCustomerEvents.forEach(function(customerEvent){
                var item = JSON.parse(JSON.stringify( toolKitItems.find(x => x.Id == customerEvent.ToolkitItemId) ));
                item.CustomerEvent = customerEvent;
                customerEvents.push(item);
            });
            return customerEvents;
        }

       

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/OneStopShop/toolkit.tpl.html',
            scope: { flight:"=", passenger:"=", treatmentAvailability : "&onTreatmentAvailability"},
            link: link
        }
    }

})();
